import React, { useState, useEffect } from "react";
import {
  PDFViewer,
  Document,
  Page,
  Text,
  PDFDownloadLink,
  Font,
  StyleSheet,
  View,
  Image,
} from "@react-pdf/renderer";
import axios from "axios";
import Encabezado from "../Informes/Encabezado";
import { useParams } from "react-router-dom";
import head from "../../img/headerPdf.PNG";
import logo from "./sualogo.jpg";
import icontec from "../../img/LOGOSeide.png";
const MyPDF = () => {
  let { idSolicitud } = useParams();
  let { idInstitucion } = useParams();
  console.log("EL ID DE INSTITUCION" + idInstitucion);

  Font.register({
    family: "Ubuntu",
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf",
      },
      {
        src: "https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf",
        fontWeight: "bold",
      },
      {
        src: "https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf",
        fontWeight: "normal",
        fontStyle: "italic",
      },
    ],
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 18,
      textAlign: "center",
      fontFamily: "Ubuntu",
    },
    author: {
      fontSize: 12,
      margin: 12,
      fontFamily: "Ubuntu",
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: "Ubuntu",
    },
    text: {
      margin: 11,
      fontSize: 14,
      textAlign: "justify",
      lineHeight: 1.5,
    },
    textdescripcion: {
      margin: 8,
      fontSize: 16,
      textAlign: "justify",
      fontFamily: "Ubuntu",
      lineHeight: 1.5,
      fontWeight: "bold",
      fontWeight: "bold",
      color: "#0085CA",
    },
    image: {
      marginVertical: 5,
      marginHorizontal: 5,
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: "center",
      color: "grey",
    },
    pageNumber: {
      position: "absolute",
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "grey",
    },
    table: {
      display: "table",
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
      borderStyle: "solid",
      width: "100%",
      borderBottomWidth: 0,
    },
    headerCell: {
      width: "50%",
      fontSize: 12,
      fontWeight: "bold",
      borderWidth: 1,
    },
    tableCell: {
      margin: "auto",
      width: "15%",
      borderStyle: "solid",
      textAlign: "center",
      borderWidth: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
      borderTopWidth: 0,
    },
    tableCellCenter: {
      margin: "auto",
      width: "60%",
      borderStyle: "solid",
      borderWidth: 0,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },

    cell: {
      fontSize: 12,
      textAlign: "center",
    },
    tableRowContenido: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "#000",
      alignItems: "center",
      height: 20,
      textAlign: "center",
      borderWidth: 1,
    },
    textHeader: {
      margin: 8,
      fontSize: 10,
      textAlign: "justify",
    },
    headerCell: {
      width: "50%",
      fontSize: 12,
      fontWeight: "bold",
      borderWidth: 0,
    },
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://suadesarrollo.azurewebsites.net/Api/ObtenerInstitucionesPorId?Id=" +
          idInstitucion,
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [data1, setData1] = useState([]);

  useEffect(() => {
    fetchData1();
  }, []);

  const fetchData1 = async () => {
    try {
      const response = await axios.get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerPerfilAutoevaluacion/" +
          idInstitucion,
      );
      setData1(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  let filtro = data1.filter((e) => e.titulo == "1.Modelo de atencion");
  let filtro1 = data1.filter(
    (e) => e.titulo == "2. Estructura organizacional ",
  );
  let filtro2 = data1.filter((e) => e.titulo == "3. organos de direccion");
  let filtro3 = data1.filter(
    (e) => e.titulo == "4. Conformacion de la alta direccion ",
  );
  let filtro4 = data1.filter(
    (e) => e.titulo == "5.Desarrollo de los ejes de acreditacion ",
  );
  let filtro5 = data1.filter(
    (e) => e.titulo == "5.1.Humanizacion de la atencion",
  );
  let filtro6 = data1.filter((e) => e.titulo == "5.2 Seguridad del paciente");
  let filtro7 = data1.filter((e) => e.titulo == "5.3. Gestion de tecnologia");
  let filtro8 = data1.filter(
    (e) => e.titulo == "5.4. Enfoque y gestion del riesgo",
  );
  let filtro9 = data1.filter(
    (e) => e.titulo == "6.5. Transformacion cultural ",
  );
  let filtro10 = data1.filter((e) => e.titulo == "5.6. Responsabilidad social");
  let filtro11 = data1.filter((e) => e.titulo == "6.Gestion de comites");
  let filtro12 = data1.filter(
    (e) => e.titulo == "7. Convenios docencia-servicio",
  );
  let filtro13 = data1.filter((e) => e.titulo == "8.Investigacion en salud");
  let filtro14 = data1.filter(
    (e) =>
      e.titulo == "9.Prestacion de servicios en modalidad de tercerizacion ",
  );
  let filtro15 = data1.filter((e) => e.titulo == "10. Acuerdos sindicales ");
  let filtro16 = data1.filter((e) => e.titulo == "11. Educacion en salud ");
  let filtro17 = data1.filter((e) => e.titulo == "12. Satisfaccion y quejas ");

  let filtro18 = data1.filter((e) => e.titulo == "1.1 URGENCIAS");
  let filtro19 = data1.filter((e) => e.titulo == "1.2 HOSPITALIZACION GENERAL");
  let filtro20 = data1.filter((e) => e.titulo == "1.3 GINECOBSTETRICIA");
  let filtro21 = data1.filter((e) => e.titulo == "1.4 CIRUGIA");
  let filtro22 = data1.filter(
    (e) => e.titulo == "1.5 CUIDADOS INTENSIVOS Y CUIDADO INTERMEDIO",
  );

  let filtro23 = data1.filter((e) => e.titulo == "2.1 CONSULTA EXTERNA ");
  let filtro24 = data1.filter((e) => e.titulo == "3. REHABILITACION ");
  let filtro25 = data1.filter((e) => e.titulo == "4. SERVICIOS DE ODONTOLOGiA");
  let filtro26 = data1.filter(
    (e) => e.titulo == "5. IMAGENES DIAGNOSTICAS Y TERAPeUTICAS ",
  );
  let filtro27 = data1.filter(
    (e) => e.titulo == "6. LABORATORIO CLINICO, BANCO DE SANGRE Y PATOLOGIA",
  );
  let filtro28 = data1.filter((e) => e.titulo == "7.SEDES INTEGRADAS");

  let filtro29 = data1.filter((e) => e.titulo == "1. Generalidades  ");
  let filtro30 = data1.filter((e) => e.titulo == "2.Infraestructura fisica");
  let filtro31 = data1.filter(
    (e) =>
      e.titulo ==
      "2.2. Planeacion, ejecucion  e impacto de obras de  infraestructura fisica",
  );
  let filtro32 = data1.filter((e) => e.titulo == "2.3. Seguridad ");
  let filtro33 = data1.filter((e) => e.titulo == "2.4. Tecnologia ");

  let filtro34 = data1.filter((e) => e.titulo == "1. Generalidades");

  let filtro35 = data1.filter((e) => e.titulo == "1.Generalidades");

  let filtro36 = data1.filter(
    (e) =>
      e.titulo ==
      "Describa de forma concreta y precisa la siguiente informacion",
  );

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOrganosControlPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerJuntaDirectivaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const [list2, setList2] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerNivelDirectivoPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList2(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList2]);
  const [list3, setList3] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerConvenioDocenciaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList3(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList3]);
  const [list4, setList4] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAcuerdosSindicalesPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList4(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList4]);
  const [list5, setList5] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerInfraestructuraPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList5(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList5]);
  const [list6, setList6] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerInfraestructuraMetrosPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList6(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList6]);
  const [list7, setList7] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerSimulacrosPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList7(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList7]);
  const [list8, setList8] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerUltimoSimulacroPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList8(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList8]);
  const [list9, setList9] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        " https://suadesarrollo.azurewebsites.net/api/ObtenerEquiposAdquiridosPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList9(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList9]);

  const [list10, setList10] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoAutoevaluacionPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList10(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList10]);
  const [list11, setList11] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoUrgenciasPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList11(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList11]);
  const [list12, setList12] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoHospitalizacionPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList12(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList12]);
  const [list13, setList13] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoCuidadosPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList13(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList13]);
  const [list14, setList14] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoCirugiaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList14(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList14]);
  const [list15, setList15] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoSangrePorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList15(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList15]);
  const [list16, setList16] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoImagenesPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList16(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList16]);

  const [list18, setList18] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoConsultaExternaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList18(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList18]);
  const [list19, setList19] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoSaludPublicaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList19(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList19]);
  const [list20, setList20] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoOncologiaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList20(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList20]);

  const [list22, setList22] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTerapiasPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList22(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList22]);

  const [list23, setList23] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoRehabilitacionCardiacaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList23(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList23]);
  const [list24, setList24] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoSaludMentalPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList24(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList24]);
  const [list25, setList25] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "ttps://suadesarrollo.azurewebsites.net/api/ObtenerEquipoOdontologiaGeneralPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList25(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList25]);
  const [list26, setList26] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoOdontologiaEspecialiazadaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList26(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList26]);
  const [list27, setList27] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoAmbulatorioPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList27(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList27]);
  const [list28, setList28] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoImagenesTerapeuticasPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList28(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList28]);
  const [list29, setList29] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoPatologiaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList29(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList29]);
  const [list30, setList30] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoDireccionamientoPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList30(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList30]);
  const [list31, setList31] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoGerenciaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList31(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList31]);
  const [list32, setList32] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTalentoHumanoPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList32(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList32]);
  const [list33, setList33] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoAmbienteFisicoPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList33(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList33]);
  const [list34, setList34] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTecnologiaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList34(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList34]);
  const [list35, setList35] = useState([]);
  useEffect(() => {
    axios({
      method: "get",

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoGerenciaInformacionPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList35(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList35]);

  return (
    <center>
      <PDFViewer width={"100%"} height="1000">
        <Document>
          <Page style={styles.body}>
            <View style={styles.table} fixed>
              <View style={styles.tableRow}>
                <View style={styles.tableCell}>
                  <Image style={styles.image} src={logo} />
                </View>
                <View style={styles.tableCellCenter}>
                  <Text style={styles.textHeader}>
                    {" "}
                    INFORME DE AUTOEVALUACIÓN INSTITUCIONES PRESTADORAS DE
                    SERVICIOS DE SALUD AMBULATORIAS, IMAGENOLOGÍA, HABILITACIÓN
                    / REHABILITACIÓN Y ODONTOLOGÍA PARTE 1. PERFIL DE LA
                    INSTITUCIÓN VISITA DE SEGUIMIENTO Y COMPLEMENTARIA VERSIÓN
                    3.1 RESOLUCIÓN 5095 DE 2018
                  </Text>
                </View>
                <View style={styles.tableCell}>
                  <Image style={styles.image} src={icontec} />
                </View>
              </View>
            </View>

            <br></br>
            <Text style={styles.title}>INDICE</Text>
            <Text style={styles.subtitle}>
              SECCION A. INFORMACIÓN GENERAL DE LA INSTITUCIÓN
            </Text>
            <Text style={styles.subtitle}>
              SECCION B. DESCRIPCIÓN DE LOS SERVICIOS
            </Text>
            <Text style={styles.author}>1. SERVICIOS HOSPITALARIOS</Text>
            <Text style={styles.author}>2. SERVICIOS AMBULATORIOS</Text>
            <Text style={styles.author}>3. REHABILITACIÓN</Text>
            <Text style={styles.author}>4. SERVICIOS DE ODONTOLOGÍA</Text>
            <Text style={styles.author}>
              5. IMÁGENES DIAGNÓSTICAS Y TERAPÉUTICA
            </Text>
            <Text style={styles.author}>
              6. LABORATORIO CLÍNICO, BANCO DE SANGRE Y PATOLOGÍA
            </Text>
            <Text style={styles.author}>7. SEDES INTEGRADAS</Text>
            <Text style={styles.subtitle}>
              SECCIÓN C. INFRAESTRUCTURA Y GESTION DE TECNOLOGÍA BIOMÉDICA
            </Text>
            <Text style={styles.subtitle}>
              SECCIÓN D. DISTRIBUCIÓN Y DESARROLLO DEL TALENTO HUMANO{" "}
            </Text>
            <Text style={styles.subtitle}>
              SECCION E. GESTION DE LA INFORMACIÓN
            </Text>
            <Text style={styles.subtitle} break></Text>
            <Text style={styles.title}>
              SECCION A. INFORMACIÓN GENERAL DE LA INSTITUCIÓN
            </Text>
            <Text style={styles.subtitle}>Misión</Text>
            {data.map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.mision}
              </Text>
            ))}
            <Text style={styles.subtitle}>Visión</Text>
            {data.map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.vision}
              </Text>
            ))}
            <Text style={styles.subtitle}>Prinicipios</Text>
            {data.map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.principios}
              </Text>
            ))}
            <Text style={styles.subtitle}>Valores</Text>
            {data.map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.valores}
              </Text>
            ))}
            <Text style={styles.subtitle}>Objetivos Estrategicos</Text>
            {data.map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.objetivosEstrategicos}
              </Text>
            ))}
            <Text style={styles.subtitle}>
              Política de Seguridad y salud en el trabajo{" "}
            </Text>
            {data.map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.politicaSeguridad}
              </Text>
            ))}
            <Text style={styles.subtitle}>1. Modelo de atención</Text>
            {filtro.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}

            <Text style={styles.subtitle}>2. Estructura organizacional </Text>
            {filtro1.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>3. Órganos de dirección</Text>
            <Text style={styles.title}>GENERALIDADES</Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Fecha</Text>
                <Text style={styles.headerCell}>Logro</Text>
              </View>
              {list.map((item) => {
                const fecha = new Date(item.fecha);

                return (
                  <View style={styles.tableRow}>
                    {item.fecha == "0001-01-01T00:00:00" ? (
                      <Text style={styles.headerCell}>Sin fecha </Text>
                    ) : (
                      <Text style={styles.headerCell}>
                        {fecha.toLocaleDateString("en-US", item.fecha)}
                      </Text>
                    )}
                    <Text style={styles.headerCell}>{item.logro}</Text>
                  </View>
                );
              })}
            </View>
            {filtro2.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>
              4.Conformación de la alta dirección
            </Text>
            <Text style={styles.title}>Integrantes de Junta directiva.</Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}>Porfesión</Text>
                <Text style={styles.headerCell}>Fecha Nombramiento</Text>
              </View>
              {list1.map((item) => {
                const fecha = new Date(item.fecha);

                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>
                      {item.fechaNombramiento}
                    </Text>

                    <Text style={styles.headerCell}>{item.logro}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.title}>Nivel directivo.</Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}>Porfesión</Text>
              </View>
              {list2.map((item) => {
                const fecha = new Date(item.fecha);

                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.profesion}</Text>
                  </View>
                );
              })}
            </View>
            {filtro3.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}

            <Text style={styles.subtitle}>
              5. Desarrollo de los ejes de acreditacion
            </Text>
            {filtro4.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>
              5.1 .Humanizacion de la atencion
            </Text>
            {filtro5.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}

            <Text style={styles.subtitle}>5.2 Seguridad del paciente</Text>
            {filtro6.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>5.3 Gestión de tecnologia</Text>
            {filtro7.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>
              5.4 Enfoque y gestion del riesgo
            </Text>
            {filtro8.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>5.5 Transformacion cultural</Text>
            {filtro9.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>5.6 Responsabilidad social</Text>
            {filtro10.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>6.Gestion de comites</Text>
            {filtro11.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>7.Convenios docencia-servicio</Text>
            {filtro12.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre Institucion</Text>
                <Text style={styles.headerCell}>Programa Academico</Text>
                <Text style={styles.headerCell}>Fecha Inicio</Text>
              </View>
              {list3.map((item) => {
                const fecha = new Date(item.fecha);

                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>
                      {item.nombre_Institucion}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.programa_Academico}
                    </Text>
                    <Text style={styles.headerCell}>{item.fecha_inicio}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>8. Investigacion en salud</Text>
            {filtro13.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>
              9. Prestacion de servicios en modalidad de tercerizacion
            </Text>
            {filtro14.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>10. Acuerdos sindicales</Text>
            {filtro15.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Fecha del Acuerdo</Text>
                <Text style={styles.headerCell}>Acuerdo Establecido</Text>
              </View>
              {list4.map((item) => {
                const fecha = new Date(item.fecha);

                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.fechaAcuerdo}</Text>
                    <Text style={styles.headerCell}>
                      {item.acuerdoEstablecido}
                    </Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>11. Educacion en salud</Text>
            {filtro16.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>12.Satisfaccion y quejas</Text>
            {filtro17.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title} break>
              {" "}
              SECCION B. DESCRIPCIÓN DE LOS SERVICIOS
            </Text>
            <Text style={styles.subtitle}> 1. SERVICIOS HOSPITALARIOS</Text>
            {filtro18.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}> 1.2 HOSPITALIZACION GENERAL</Text>
            {filtro19.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>1.3 GINECOBSTETRICIA</Text>
            {filtro20.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>1.4 CIRUGIA</Text>
            {filtro21.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}> 2.SERVICIOS AMBULATORIOS</Text>
            <Text style={styles.subtitle}>2.1 CONSULTA EXTERNA</Text>
            {filtro23.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>3.REHABILITACION</Text>
            {filtro24.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>4.REHABILITACION</Text>
            {filtro25.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>
              5. IMAGENES DIAGNOSTICAS Y TERAPEUTICAS
            </Text>
            {filtro26.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>
              {" "}
              6. LABORATORIO CLINICO, BANCO DE SANGRE Y PATOLOGIA
            </Text>
            {filtro27.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}> 7.SEDES INTEGRADAS</Text>
            {filtro28.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>
              {" "}
              SECCIÓN C. INFRAESTRUCTURA Y GESTION DE TECNOLOGÍA BIOMÉDICA
            </Text>
            <Text style={styles.subtitle}>1.Generalidades</Text>
            {filtro29.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>Infraestructura</Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Sede</Text>
                <Text style={styles.headerCell}>
                  Fecha inicial de construcción
                </Text>
                <Text style={styles.headerCell}>Novedad</Text>
                <Text style={styles.headerCell}>Fecha Inspeccion</Text>
                <Text style={styles.headerCell}>Cumplimiento Normas</Text>
                <Text style={styles.headerCell}>Reforzamiento</Text>
              </View>
              {list5.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.sede}</Text>
                    <Text style={styles.headerCell}>{item.fecha_Inicial}</Text>
                    <Text style={styles.headerCell}>{item.novedad}</Text>
                    <Text style={styles.headerCell}>
                      {item.fecha_Inspeccion}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.cumplimiento_Normas}
                    </Text>
                    <Text style={styles.headerCell}>{item.reforzamiento}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>Infraestructura</Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Sede</Text>
                <Text style={styles.headerCell}>Metros Fisicos</Text>
                <Text style={styles.headerCell}>Metros Construidos</Text>
                <Text style={styles.headerCell}>Metros Sala Espera</Text>
                <Text style={styles.headerCell}>Metros Urgencias</Text>
                <Text style={styles.headerCell}>Metros Radiologia</Text>
                <Text style={styles.headerCell}>Metros Cirugia</Text>
                <Text style={styles.headerCell}>Metros Partos</Text>
              </View>
              {list6.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.sede}</Text>
                    <Text style={styles.headerCell}>{item.metros_fisicos}</Text>
                    <Text style={styles.headerCell}>
                      {item.metros_Construidos}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.metros_Sala_Espera}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.metros_Urgencias}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.metros_Radiologia}
                    </Text>
                    <Text style={styles.headerCell}>{item.metros_Cirugia}</Text>
                    <Text style={styles.headerCell}>{item.metros_Partos}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}> 2.Infraestructura fisica</Text>
            {filtro30.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>
              2.2. Planeacion, ejecucion e impacto de obras de infraestructura
              fisica
            </Text>
            {filtro31.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.subtitle}>2.3. Seguridad</Text>
            <Text style={styles.subtitle}>
              últimos cuatro años la siguiente tabla, relacionando los
              diferentes tipos de simulacros realizados, por ejemplo, incendio,
              evacuación, entre otros, discriminando por sedes si aplica.
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>fechaSimulacro</Text>
                <Text style={styles.headerCell}>recomendaciones</Text>
                <Text style={styles.headerCell}>
                  seguimientoRecomendaciones
                </Text>
              </View>
              {list8.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.fechaSimulacro}</Text>
                    <Text style={styles.headerCell}>
                      {item.recomendaciones}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.seguimientoRecomendaciones}
                    </Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              simulacros realizados en el último año y frente a cada uno
              describa las dos principales recomendaciones y el seguimiento a la
              implementación de las mismas
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>fechaSimulacro</Text>
                <Text style={styles.headerCell}>recomendaciones</Text>
                <Text style={styles.headerCell}>
                  seguimientoRecomendaciones
                </Text>
              </View>
              {list8.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.fechaSimulacro}</Text>
                    <Text style={styles.headerCell}>
                      {item.recomendaciones}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.seguimientoRecomendaciones}
                    </Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}> 2.Infraestructura fisica</Text>
            {filtro32.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Marca</Text>
                <Text style={styles.headerCell}>Modelo</Text>
                <Text style={styles.headerCell}>Fecha Adquisiscion</Text>
                <Text style={styles.headerCell}>Garantia</Text>
                <Text style={styles.headerCell}>Años de vida Util</Text>
                <Text style={styles.headerCell}>Tipo de riesgo</Text>
                <Text style={styles.headerCell}>Clasificación Biomedica</Text>
                <Text style={styles.headerCell}>Periodicidad</Text>
                <Text style={styles.headerCell}>Fecha Mantenimiento</Text>
              </View>
              {list9.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.marca}</Text>
                    <Text style={styles.headerCell}>{item.modelo}</Text>
                    <Text style={styles.headerCell}>
                      {item.fecha_Adquisiscion}
                    </Text>
                    <Text style={styles.headerCell}>{item.garantia}</Text>
                    <Text style={styles.headerCell}>{item.anos_vida_util}</Text>
                    <Text style={styles.headerCell}>{item.tipo_riesgo}</Text>
                    <Text style={styles.headerCell}>
                      {item.clasificacion_biomedica}
                    </Text>
                    <Text style={styles.headerCell}>{item.periodicidad}</Text>
                    <Text style={styles.headerCell}>
                      {item.fecha_mantenimiento}
                    </Text>
                    <Text style={styles.headerCell}>
                      {item.numero_Mantenimientos}
                    </Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>2.4. Tecnologia</Text>
            {filtro33.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>
              {" "}
              SECCIÓN D. DISTRIBUCIÓN Y DESARROLLO DEL TALENTO HUMANO
            </Text>
            <Text style={styles.subtitle}>1. Generalidades</Text>
            {filtro34.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>
              SECCION E. GESTION DE LA INFORMACIÓN
            </Text>
            <Text style={styles.subtitle}>1. Generalidades</Text>
            {filtro35.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}
            <Text style={styles.title}>
              SECCION F. AUTOEVALUACION DE ESTANDARES Y ESTRUCTURA DEL
              MEJORAMIENTO
            </Text>
            {filtro36.map((item, index) => (
              <View key={index}>
                <Text style={[styles.textdescripcion, styles.subrayadoText]}>
                  {item.subtitulos}
                </Text>
                <Text style={styles.text}>{item.descripcion}</Text>
              </View>
            ))}

            <Text style={styles.title}>
              SECCION G. Equipos y autoevaluación de estándares del proceso de
              atención cliente asistencial
            </Text>
            <Text style={styles.subtitle}>
              Equipo de autoevaluación hospitalario
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list10.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de urgencias
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list11.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de hospitalización
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list12.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de cuidados intensivos
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list13.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de cirugía
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list14.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de laboratorio clinico, banco de sangre y
              Patología
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list15.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de imagenes Diagnósticos y terapéuticas
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list16.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de consulta externa medica y Paramédica
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list18.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de mejoramiento de consulta Oncología
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list20.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de salud publica y promoción y
              prevención
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list19.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de
              terapias(Fisicas,ocupacional,lenguaje y respiratoria)
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list22.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de Rehabilitación
              cardiaca,pulmonar y visual
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list23.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de Psicología y salud mental
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list24.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de Odontología
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list25.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de Odontología especializada
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list26.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de Cirugia ambulatoria
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list27.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo primario de mejoramiento de Imagenes terapéuticas
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list28.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>Equipo primario de Patología</Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list29.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.title}>
              SECCION H. Autoevaluación de estándares de apoyo
            </Text>
            <Text style={styles.subtitle}>
              Equipo de autoevaluación de direccionamiento
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list30.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de autoevaluación de gerencia
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list31.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de autoevaluación de gerencia del talento humano
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list32.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>

            <Text style={styles.subtitle}>
              Equipo de autoevaluación de gerencia del ambiente físico
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list33.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de autoevaluación de gestión de tecnología
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list34.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>
            <Text style={styles.subtitle}>
              Equipo de autoevaluación de gerencia de la información
            </Text>
            <View>
              <View style={styles.tableRow}>
                <Text style={styles.headerCell}>Nombre</Text>
                <Text style={styles.headerCell}>Servicio</Text>
                <Text style={styles.headerCell}>Cargo</Text>
                <Text style={styles.headerCell}> Lider</Text>
              </View>
              {list35.map((item) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.headerCell}>{item.nombre}</Text>
                    <Text style={styles.headerCell}>{item.servicio}</Text>
                    <Text style={styles.headerCell}>{item.cargo}</Text>
                    <Text style={styles.headerCell}>{item.lider}</Text>
                  </View>
                );
              })}
            </View>

            <Text style={styles.title}>
              SECCION I. Autoevaluación de estándares de mejoramiento de la
              calidad
            </Text>
          </Page>
        </Document>
      </PDFViewer>
    </center>
  );
};

export default MyPDF;
